"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonschema_1 = require("../../utils/jsonschema");
var schema = {
    $id: jsonschema_1.$id('arrayExpression'),
    title: 'Array expression',
    anyOf: [
        {
            type: 'array',
            items: {
                $ref: jsonschema_1.$id('expression')
            }
        },
        { $ref: jsonschema_1.$id('sortExpression') },
        { $ref: jsonschema_1.$id('concatExpression') },
        { $ref: jsonschema_1.$id('entriesExpression') },
        { $ref: jsonschema_1.$id('untypedResolvedExpression') }
    ]
};
exports.default = schema;
//# sourceMappingURL=array.schema.js.map